import { render, staticRenderFns } from "./ModalChangeTheme.vue?vue&type=template&id=b5cbd762&scoped=true&"
import script from "./ModalChangeTheme.vue?vue&type=script&lang=js&"
export * from "./ModalChangeTheme.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangeTheme.vue?vue&type=style&index=0&id=b5cbd762&prod&lang=scss&"
import style1 from "./ModalChangeTheme.vue?vue&type=style&index=1&id=b5cbd762&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cbd762",
  null
  
)

export default component.exports